export const SET_FRONTEND_PREVIEW_URL = 'SET_FRONTEND_PREVIEW_URL';
export const SET_VIEWPORT_PRESET = 'SET_VIEWPORT_PRESET';
export const SET_VIEWPORT_WIDTHS = 'SET_VIEWPORT_WIDTHS';
